// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'

class PostContent extends React.Component {
	render() {
		const { contentId, sectionId, data, page } = this.props

		if ( ! data ) {
			return null
		}

		const pageContent = page.html_override ? (
			<div className="content-custom-wrap" dangerouslySetInnerHTML={ { __html: page.html_override } }></div>
		) : (
			<div className="content-body-wrap">
				<div className="content-body">
					<Editable
						id={ contentId }
						sectionId={ sectionId }
						sectionType={ data.type }
						sectionDataId="content"
						className="content-body-text"
						content={ data.content }
					/>
				</div>
			</div>
		)

		return (
			<div className="section-post-content">
				<div className="-inner">
					<div className="primary-content-inner primary-content-is-ready">
						{ pageContent }
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( PostContent )
